import { CreateCandidateWithAttachments } from './CreateCandidateWithAttachments'

/**
 * Every user uploads the CV as a file: it stays attached to the candidate,
 * is downloadable, and goes to the model when scorecards are generated.
 * CreateCandidateLegacy (CV parsed to text in the browser, file discarded) is
 * kept only as a rollback target.
 */
export const CreateCandidate = () => <CreateCandidateWithAttachments />
